<div class="page_container">
    <ui-page-header [title]="'settings.notifications' | translate" [lucideIcon]="'Bell'"></ui-page-header>
    <!-- The header carries no subtitle slot by design; the explanatory copy sits
         below it instead of being wedged into the title block. -->
    <p class="page_description">{{"settings.notification_description" | translate}}</p>

    <div class="notifications__content">

        <!-- ── Notification types ──────────────────────────────────────────── -->
        <section class="settings_section">
            <h2 class="section_title">{{"settings.notification_type" | translate}}</h2>

            <div class="table_card">
                <table class="settings_table">
                    <thead>
                        <tr>
                            <th>{{"common.name" | translate}}</th>
                            <th class="col_toggle"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Clicking a row switches which notification's recipients the
                             section below edits. There is no selected-row tint: the
                             current type is named beside the Recipients heading instead,
                             which says what the selection means rather than leaving a
                             second row colour to be decoded. The toggle stops propagation
                             so it never changes the selection. -->
                        <tr
                            *ngFor="let notificationsType of allNotifications; let i = index"
                            class="row--selectable"
                            (click)="setActiveNotification(i)">
                            <td>
                                {{'settings.notification_types.' + getNotificationTypeDisplayName(notificationsType) | translate}}
                            </td>
                            <td class="col_toggle" (click)="$event.stopPropagation()">
                                <mat-slide-toggle [checked]="true" color="primary"></mat-slide-toggle>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- ── Recipients ──────────────────────────────────────────────────── -->
        <section class="settings_section">
            <div class="section_heading">
                <h2 class="section_title">{{"settings.notification_recipients" | translate}}</h2>
                <!-- Names the type selected above, so the master/detail relationship is
                     explicit. Reuses the already-translated type name — no new copy. -->
                <span class="section_tag" *ngIf="notification">
                    {{'settings.notification_types.' + getNotificationTypeDisplayName(notification) | translate}}
                </span>
            </div>

            <div class="table_card">
                <table class="settings_table">
                    <thead>
                        <tr>
                            <th>{{"common.name" | translate}}</th>
                            <th>{{"common.email" | translate}}</th>
                            <th class="col_actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let recipient of recipients">
                            <td>
                                <div class="recipient_cell">
                                    <img
                                        *ngIf="getUserAvatarSrc(recipient.image); else recipientInitials"
                                        class="recipient_avatar recipient_avatar--photo"
                                        [src]="getUserAvatarSrc(recipient.image)"
                                        [alt]="recipient.name">
                                    <ng-template #recipientInitials>
                                        <span
                                            class="recipient_avatar"
                                            [style.background-color]="getUserColor(recipient)">
                                            {{ getUserInitials(recipient) }}
                                        </span>
                                    </ng-template>
                                    <span class="recipient_name">{{recipient.name}}</span>
                                </div>
                            </td>
                            <td class="recipient_email">{{recipient.email}}</td>
                            <td class="col_actions">
                                <button
                                    type="button"
                                    class="icon_action icon_action--danger"
                                    (click)="removeRecipient(recipient)"
                                    [attr.aria-label]="'common.delete' | translate">
                                    <ui-icon name="Trash2" size="large"></ui-icon>
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="!recipients?.length">
                            <td colspan="3" class="empty_row">{{"common.no_data" | translate}}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Pinned inside the card, mirroring where pagination sits on the
                     other settings tables. -->
                <div class="table_footer">
                    <button type="button" class="add_recipient" (click)="addRecipient()">
                        <ui-icon name="Plus" size="medium"></ui-icon>
                        <span>{{"settings.add_recipient" | translate}}</span>
                    </button>
                </div>
            </div>
        </section>

    </div>
</div>
